




import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import BaseView from "@/components/Base/Elements/BaseView.vue";

const AppStore = namespace("App");

@Component({
  extends: BaseView
})
export default class HomeView extends Vue {
  @AppStore.State
  canPublishReport!: boolean;

  @AppStore.State
  canPublishPreliminaryReport!: boolean;

  async mounted() {
    await this.$store.dispatch("App/getConfig");

    if (this.canPublishPreliminaryReport) {
      this.$router.push("/preliminary-report");
    } else {
      this.$router.push("/report");
    }
  }
}
